<template>
    <div class="container-ths">
        <AuthHeader :backLink=true />
        <div class="container is-centered sign-in">
            <SignInForm :mode="routerName"
                        :header-title="$t('forgot_password')"
                        :button-title="$t('reset_password')"
                        show-errors
            />
        </div>
    </div>
</template>

<script>
    import SignInForm from '@/components/SignInForm.vue'
    import AuthHeader from '@/components/AuthHeader.vue'

    export default {
        name: "ForgotPassword",
        components: {SignInForm,AuthHeader},
        computed: {
            routerName() {
                return this.$route.name;
            }
        }
    }
</script>

<style scoped>

</style>
